import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('COUNTRIES');
